module.exports = __webpack_public_path__ + "static/img/eicad_img3.af7af2ee.png";